module.exports = __webpack_public_path__ + "static/media/hello-world.b739e0ac.proto";